export type MobileMenuState = {
  isVisible: boolean;
  isMobileChatBotVisible: boolean;
};

export type SearchQueryState = {
  searchQuery: string;
  searchStatus: boolean;
  offersSearchStatus: boolean;
  searchId: string | null;
  preserveSearchId: boolean;
};

export type TempState = {
  isNarrowLayout: boolean;
};

export type AppStoreState = MobileMenuState & SearchQueryState & TempState;

export const AppStoreState: AppStoreState = {
  isNarrowLayout: false,
  isVisible: false,
  isMobileChatBotVisible: false,
  searchQuery: '',
  searchStatus: false,
  offersSearchStatus: false,
  searchId: null,
  preserveSearchId: false,
};
